// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1TDUV","productName":"Table_productName__2YRWe"};